import { render, staticRenderFns } from "./SiteTablets.vue?vue&type=template&id=772176ee&"
import script from "./SiteTablets.vue?vue&type=script&lang=js&"
export * from "./SiteTablets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports